const themeStyles = colors => {
  const styles = {
    divider: {
      backgroundColor: colors.silverGray,
      height: 1,
      margin: '20px 0'
    },
    tinyDivider: {
      backgroundColor: colors.silverGray,
      margin: '10px 0'
    }
  }
  return styles
}
export default themeStyles
